// extracted by mini-css-extract-plugin
module.exports = {"headline":"PityHeader_headline__v1C1C","title":"PityHeader_title__HU4_4","underline":"PityHeader_underline__dwV5_","small":"PityHeader_small__V6V9w"};